<div class="update-claim-modal" *transloco="let t; prefix: 'accidents.modals.updateClaim'">
  <div class="update-claim-modal__header">
    <h3 class="update-claim-modal__title">{{ t('title') }}</h3>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="cancel()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  <form [formGroup]="updateForm" class="update-claim-modal__form">
    <div class="form-step">
      <div class="form-group">
        <label class="form-label">{{ t('claimStatus') }} <span class="required">*</span></label>
        <div ngbDropdown class="dropdown-wrapper" [autoClose]="true">
          <button type="button" class="form-control dropdown-toggle" ngbDropdownToggle>
            <div class="dropdown-inner">
              <span>{{ statusLabel }}</span>
              <i class="ph ph-caret-down"></i>
            </div>
          </button>
          <div ngbDropdownMenu class="dropdown-menu">
            @for (status of statuses; track status.id) {
              <button type="button" class="dropdown-item" (click)="onStatusSelect(status)" ngbDropdownItem>
                {{ status.name }}
              </button>
            }
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="settledAmount" class="form-label">{{ t('settledAmount') }}</label>
        <input
          type="text"
          id="settledAmount"
          formControlName="settledAmount"
          class="form-control"
          [placeholder]="t('settledAmountPlaceholder')">
      </div>
    </div>
  </form>

  <div class="update-claim-modal__actions">
    <button type="button" class="btn-cancel" (click)="cancel()">
      <span>{{ 'common.cancel' | transloco }}</span>
    </button>
    <button type="button" class="btn-save" (click)="save()" [disabled]="!isFormValid || isSubmitting">
      <span>{{ t('submit') }}</span>
    </button>
  </div>
</div>